import { render } from "./StatsUserAgeCount.vue?vue&type=template&id=0e801448"
import script from "./StatsUserAgeCount.vue?vue&type=script&lang=js"
export * from "./StatsUserAgeCount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__